import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import classes from './index.module.scss'

export const HighlightItem = ({ item }) => {
  const scrollToElement = () => {
    const scrollDiv = document.querySelector(
      '#PORTFOLIO_SCROLL_ID .scrollbars div:first-child',
    )
    const scrollElement = item.scrollElementClass
      ? document.getElementsByClassName(item.scrollElementClass)?.[0]
      : item.scrollElementId
      ? document.getElementById(item.scrollElementId)
      : undefined

    if (scrollDiv && scrollElement) {
      scrollDiv.scrollTo({
        top: scrollElement.offsetTop,
        behavior: 'smooth',
      })
    }

    if (item.otherBehavior) {
      item.otherBehavior()
    }
  }

  const handleDetailClick = () => {
    if (item.onDetailClick) {
      item.onDetailClick(scrollToElement)
    } else {
      scrollToElement()
    }
  }

  return (
    <div className={classes.highlightItem}>
      <Element
        className={classes.title}
        style={{ color: '#3a414b', fontSize: 14 }}
      >
        {item.isI18n ? <Translate value={item.title} /> : item.title}
      </Element>
      <Element
        className={classes.detail}
        style={{ color: '#0553a5', fontSize: 14 }}
        onClick={handleDetailClick}
      >
        {item.formatDetail ? item.formatDetail(item.detail) : item.detail}
        &nbsp;
      </Element>
    </div>
  )
}
